import axios from 'axios';

export default class QuestionQuery {
  static getNewsList(queryBody) {
    return axios
      .post('/api/news-list', queryBody, {
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 10000
      })
      .then(
        res => {
          return Promise.resolve(res.data);
        },
        () => {
          return false;
        }
      );
  }
  static getHotWordLists(company, count) {
    return axios.get(`/api/company-news-keywords?company=${company}&count=${count}`).then(res => {
      return res.data || [];
    }, (err) => {
      return Promise.reject(err);
    });
  }
  static getHotNewsList(searchText) {
    return axios
      .post('/api/news-hot', {
        searchText,
        count: 5
      })
      .then(
        res => {
          return res.data || [];
        },
        () => {
          return [];
        }
      );
  }

  static getHotEventList(count) {
    return axios.get(`/v1/api/event/hot?count=${count}`).then(res => {
      return res.data || [];
    }, () => {
      // return axios.get('/mock/hot-events.json').then(res => res.data.slice(0, count));
      // TODO: error checking?
      return [];
    });
  }

  static getEventTrend(eventId) {
    return axios.get(`/v1/api/event/trend/${eventId}`).then(res => res.data, () => {
      return {};
      // return axios.get('/mock/event-trend.json').then(res => res.data);
    });
  }
  // 告警
  static getEntityAlarmSetting(name) {
    return axios.get(`/api/entity_alarm_setting?name=${name}`).then(
      res => {
        return res.data || {};
      },
      () => {
      // return axios.get('/mock/entity_alarm_setting.json').then(res => res.data);
      }
    );
  }

  static setEntityAlarmSetting(addObj) {
    return axios.put('/api/entity_alarm_setting', {
      name: addObj.name,
      status: addObj.status,
      categories: addObj.categories,
      threshold: addObj.threshold
    })
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }
  // 图谱查公司
  static checkCompanyProfile(company, relatedcompanyType, relation) {
    return axios.post('/v1/api/atlas/company', { company, related_company_type: relatedcompanyType, relation }).then(res => {
      return res.data || [];
    }, 
    (err) => {
      return Promise.reject(err);
    });
  }
  static getAlarmList() {
    return axios.get('/api/alarm_list').then(res => {
      return res.data || [];
    }, 
    (err) => {
      return Promise.reject(err);
    });
  }

  static putReadAlarm(alarmId) {
    return axios.put(`/api/read_alarm/${alarmId}`).then(res => res.data, () => {
      return {};
    });
  }

  static readAllAlarm() {
    return axios.post('/api/read_all_alarms').then(
      res => {
        return res.data || [];
      },
      () => {
        return [];
      }
    );
  }

  static getEntityHotNewsList(searchText = '', Count = 3) {
    return axios.post('/api/news-hot', {
      searchText,
      Count
    }).then(
      res => {
        return res.data || [];
      },
      () => {
        return [];
      }
    );
  }

  static getTopNewsList(type = 'all', dateType = 'week', count) {
    return axios
      .post('/api/top-news-list', {
        type,
        dateType,
        count
      })
      .then(
        res => {
          return res.data || [];
        },
        () => {
          return [];
        }
      );
  }

  static getLineChartData(searchText, dateType) {
    return axios.post('/api/news-trend', { searchText, dateType }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }

  static getEntityNewsStatistics(searchText, dateType) {
    return axios.get(`/v1/api/company/risk/count?type=${dateType}&company=${searchText}`).then(res => res.data || [], () => []);
  }

  static getNewsListFiltersData(username, searchText, option, groups) {
    return axios.post('/api/news-list-filters', { 
      username, searchText, option, groups 
    }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static addMonitor(username, companyName, groups) {
    return axios.post('/api/add_monitor', { 
      username, companyName, groups 
    }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static deleteMonitor(user, company, groups) {
    return axios.delete('/v1/api/monitor/company', { data: { user, company, groups } }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static deleteMonitorCompanies(user, companies) {
    return axios.delete('/v1/api/monitor/companies', { data: { user, companies } }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static getMonitorStatus(username, companyName) {
    return axios.post('/api/monitor_status', { username, companyName }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static getMonitorGroupList(username) {
    return axios.post('/api/monitor_group_list', { username }).then(
      res => {
        return res.data || [];
      },
      () => {
        return false;
      }
    );
  }
  static addMonitorGroup(user, company, groups) {
    return axios.post('/v1/api/monitor/company', { user, company, groups }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static deleteMonitorGroup(username, groupName) {
    return axios.post(`/api/delete_monitor_group?username=${username}&groupName=${groupName}`).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }

  static getMonitorList(user, pageNum, pageSize, groups) {
    return axios
      .post('/v1/api/monitor/company/list', { 
        user, 
        page_num: pageNum,
        page_size: pageSize,
        groups
      })
      .then(
        res => {
          return res.data || {};
        },
        () => {
          return false;
        }
      );
  }

  static companyMatch(companies) {
    return axios
      .post('/v1/api/company/match', { 
        companies
      })
      .then(
        res => {
          return res.data || {};
        },
        () => {
          return false;
        }
      );
  }
  static batchMonitorCompanies(user, companies, groups) {
    return axios
      .post('/v1/api/monitor/companies', { 
        user,
        companies,
        groups
      })
      .then(
        res => {
          return res.data || {};
        },
        () => {
          return false;
        }
      );
  }
  static macroPublicList(obj) {
    return axios.post('/v1/api/macro-economy-list', obj).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err);
      }
    );
  } 

  static updateMonitor(user, company, groups) {
    return axios.put('/v1/api/monitor/company', { user, company, groups }).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static payAttentionToCompany(user, company) {
    return axios.get(`/v1/api/monitor/company/status?user=${user}&company=${company}`).then(res => {
      return res.data;
    },
    () => {
      return false;
    });
  }

  static regionRankWithRisks(risks, dateRange) {
    return axios.post('/api/region_rank_with_risks', { risks, dateRange }).then(
      res => {
        return res.data || [];
      },
      () => {
        return false;
      }
    );
  }
  static getRiskBar(region, startDate, endDate) {
    return axios.get(`/api/risk_bar?region=${region}&startDate=${startDate}&endDate=${endDate}`).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }
  static getRiskRankWithRegion(region, startDate, endDate) {
    return axios.get(`/api/risk_rank_with_region?region=${region}&startDate=${startDate}&endDate=${endDate}`).then(
      res => {
        return res.data || [];
      },
      () => {
        return false;
      }
    );
  }
  static putAlarmSettingStatus(obj) {
    // 设置页面总开关状态改变
    return axios.put('/api/alarm_setting_status', obj).then(
      () => {
        return true;
      },
      () => {
        return false;
      }
    );
  }
  static putAlarmNotificationType(obj) {
    // 设置页面告警方式
    return axios.put('/api/alarm_notification_type', obj).then(
      () => {
        return true;
      },
      () => {
        return false;
      }
    );
  }
  static putCompanyAlarmSetting(obj) {
    // 设置页面管理告警公司部分，单个公司状态改变
    return axios.put('/api/entity_alarm_setting', obj).then(
      () => {
        return true;
      },
      () => {
        return false;
      }
    );
  }
  static getAlarmSettingsPageList() {
    // 设置页面总数据拉取
    return axios.get('/api/alarm_settings').then(
      res => {
        return res;
      },
      // () => {
      //   return axios.get('/mock/alarm-settings.json');
      // }
    );
  }

  static feedback(addObj) {
    return axios.post('/api/feedback', addObj)
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static searchTermsRecommend(searchTerms) {
    return axios.post('/api/search_terms_recommend', { searchTerms })
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static similarityNewsList(newsId) {
    return axios.get(`/v1/api/news-similarity?newsId=${newsId}`)
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static getSentimentTrends(entity, startDate, endDate, count = 8) {
    return axios.get(`/v1/api/company/event/trend?entity=${entity}&start_date=${startDate}&end_date=${endDate}&count=${count}`).then(res => {
      return {
        // hotIndex: res.data.hotIndex || [],
        // positiveIndex: res.data.positiveIndex || [],
        // negativeIndex: res.data.negativeIndex || [],
        number: res.data.number || [],
        sentiment: res.data.sentiment || [],
        events: res.data.events || []
      };
    }); 
  }

  static getSearchData(pageNum, pageSize, searchText) {
    return axios.post('/api/search', { pageNum, pageSize, searchText }).then(
      res => {
        return res.data || {};
      },
      () => {
        // return axios.get('/mock/search.json').then(res => res.data);
      }
    );
  }

  static getCompanyNameSearch(searchTerms) {
    return axios.post('/api/company_name_search', { searchTerms }).then(
      res => {
        return res.data || {};
      },
      () => {
        // return axios.get('/mock/search.json').then(res => res.data);
      }
    );
  }

  static allowRegister(obj) {
    return axios.post('/v1/api/register', obj).then(
      res => {
        return res.data || {};
      },
      () => {
        // return axios.get('/mock/search.json').then(res => res.data);
      }
    );
  }

  static checkPermissions(phoneNumber) {
    return axios.get(`/v1/api/admin/${phoneNumber}`).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeHotEvents(username) {
    return axios.post('/api/home-hot-events', { username }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeMonitorStatistics(username) {
    return axios.post('/api/home-monitor-statistics', { username }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeOverviewDigital(username) {
    return axios.post('/api/home-overview-digital', { username }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeOverviewChart(username, type) {
    return axios.post('/api/home-overview-chart', { username, type }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeRisk(username) {
    return axios.post('/api/home-risk', { username }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeIndex(username, type, showAll) {
    return axios.post('/api/home-index', { username, type, showAll }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeIndexRise(username, type, showAll) {
    return axios.post('/api/home-index-rise', { username, type, showAll }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeNewsList(username, type, showAll, latestTime) {
    return axios.post('/api/home-news-list', { 
      username, 
      type, 
      showAll, 
      latestTime 
    }).then(
      res => {
        return res.data || {};
      }
    );
  }

  static homeHotEventList(username) {
    return axios.post('/api/home-hot-event-list', { username }).then(
      res => {
        return res.data || {};
      }
    );
  }
  
  static judgeAddMonitor(companies, username) {
    return axios.post('/api/judge_add_monitor', { companies, username })
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static batchAddMonitor(companies, username) {
    return axios.post('/api/batch_add_monitor', { companies, username })
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static bulletinList(username, pageNum, pageSize) {
    return axios.post('/api/bulletin-list', { username, pageNum, pageSize })
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static deleteBulletin(id) {
    return axios.delete(`/api/delete-bulletin?id=${id}`).then(
      res => {
        return res.data || {};
      },
      () => {
        return false;
      }
    );
  }

  static getNewsListTagV2(type, company) {
    return axios.get(`/v1/api/news-list-tag?type=${type}&company=${company}`).then(
      res => {
        return Promise.resolve(res.data);
      }
    ).catch(err => {
      return Promise.reject(err);
    });
  }

  static getNewsListSource() {
    return axios.get('/v1/api/news-list-source').then(
      res => {
        return Promise.resolve(res.data);
      }
    ).catch(err => {
      return Promise.reject(err);
    });
  }

  static getNewsListMarket() {
    return axios.get('/v1/api/news-list-market').then(
      res => {
        return Promise.resolve(res.data);
      }
    ).catch(err => {
      return Promise.reject(err);
    });
  }

  static getNewsDetail(id) {
    return axios.get(`/v1/api/news-detail?id=${id}`).then(
      res => {
        return Promise.resolve(res.data);
      }
    ).catch(err => {
      return Promise.reject(err);
    });
  }

  static getNewsListV2(params) {
    return axios.post('/v1/api/news-list', params).then(
      res => {
        return Promise.resolve(res.data);
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getCompanyRiskNewsListV2(params) {
    return axios.post('/v1/api/company/risk/count/news', params).then(
      res => {
        return Promise.resolve(res.data);
      }
    ).catch(err => {
      return Promise.reject(err);
    });
  }

  static getIndustryNewsList(params) {
    return axios.post('/v1/api/industry-news-list', params).then(
      res => {
        return Promise.resolve(res.data);
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static newCompaniesOfConcern(obj) {
    return axios.post('/v1/api/monitor/company', obj).then(
      res => {
        return Promise.resolve(res.data);
      }
    ).catch(err => {
      return Promise.reject(err);
    });
  }

  static getNewsIndustryTags(type) {
    return axios.get(`/v1/api/news-industry-tags?type=${type}`).then(
      res => {
        return Promise.resolve(res.data);
      }
    ).catch(err => {
      return Promise.reject(err);
    });
  }

  static searchTextRecommend(searchText) {
    return axios.get(`/v1/api/search_text_recommend?searchText=${searchText}`)
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static focusGroupsList(user) {
    return axios.get(`/v1/api/monitor/group/${user}`)
      .then(
        res => {
          return res.data || [];
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static addFocusGroups(obj) {
    return axios.post('/v1/api/monitor/group', obj)
      .then(
        res => {
          return res.data;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }

  static getSearchDataV1(pageNum, pageSize, searchText, date) {
    return axios.post('/v1/api/search', { 
      pageNum, 
      pageSize, 
      searchText, 
      date 
    }).then(
      res => {
        return res.data || {};
      },
      () => {
        // return axios.get('/mock/search.json').then(res => res.data);
      }
    );
  }

  static getCompanyNameSearchV1(searchText) {
    return axios.get(`/v1/api/search/company?searchText=${searchText}`).then(
      res => {
        return res.data || {};
      },
      () => {
        // return axios.get('/mock/search.json').then(res => res.data);
      }
    );
  }

  static getEventNews(eventId, pageNum, pageSize) {
    return axios.post('/v1/api/event/news', { eventId, pageNum, pageSize }).then(
      res => {
        return res.data || {};
      },
      () => {
        // return axios.get('/mock/search.json').then(res => res.data);
      }
    );
  }

  static getIndustryRanking(type, count, timeType) {
    return axios.get(`/v1/api/rank?type=${type}&count=${count}&timeType=${timeType}`).then(
      res => {
        return res.data || {};
      }
    );
  }

  static getCompanyIndexRanking(type, emotion, count, market) {
    return axios.get(`/v1/api/rank?type=${type}&emotion=${emotion}&count=${count}&market=${market}`).then(
      res => {
        return res.data || {};
      }
    );
  }

  static getStockCode(company) {
    return axios.get(`/v1/api/company/stock-code?company=${company}`).then(
      res => {
        return res.data || '';
      }
    );
  }

  static getPerimeter(company) {
    return axios.get(`/v1/api/company/perimeter/list?company=${company}`).then(
      res => {
        return res.data || '';
      }
    );
  }

  // static getEarliestImportantNews(earliestNewsId, pageNum, pageSize, latestNewsId) {
  static getEarliestImportantNews(params) {
    return axios.post('/v1/api/recommend/important-news', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorImportantNews(params) {
    return axios.post('/v1/api/monitor/company/important-news', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorImportantNewsNonRelated(params) {
    return axios.post('/v1/api/monitor/company/important-news-non-related', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorIndustryImportantNews(params) {
    return axios.post('/v1/api/monitor/industry/important-news', params).then(
      res => {
        return res.data;
      }
    );
  } 

  static getNewsFlashOld(pageNum, pageSize, earliestNewsId) {
    return axios.get(`/v1/api/recommend/news-flash-old?pageNum=${pageNum}&pageSize=${pageSize}&earliestNewsId=${earliestNewsId}`).then(
      res => {
        return res.data || '';
      }
    );
  }

  static getNewsFlashNew(latestNewsId) {
    return axios.get(`/v1/api/recommend/news-flash-new?latestNewsId=${latestNewsId}`).then(
      res => {
        return res.data || '';
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorCompanyCount(username) {
    return axios.get(`/v1/api/monitor/company/count/${username}`).then(
      res => {
        return res.data || '';
      }
    );
  } 

  static getMonitorIndustryCount(username) {
    return axios.get(`/v1/api/monitor/industry/count/${username}`).then(
      res => {
        return res.data || '';
      }
    );
  }

  static getRecommendEvent(pageNum, pageSize, order, eventId) {
    return axios.post('/v1/api/recommend/event', { 
      page_num: pageNum, 
      page_size: pageSize, 
      order, 
      event_id: eventId 
    }).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorCompanyEvent(params) {
    return axios.post('/v1/api/monitor/company/event', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorCompanyEventNonRelated(params) {
    return axios.post('/v1/api/monitor/company/event-non-related', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getHotEvent() {
    return axios.get('/mock/hot-events.json').then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorCompanyNewsList(params) {
    return axios.post('/v1/api/monitor/company/news-list', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorCompanyRank(user, groups, sentiment) {
    return axios.post('/v1/api/monitor/company/rank', { user, groups, sentiment }).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorCompanyTag(user, groups) {
    return axios.post('/v1/api/monitor/company/tag', { user, groups }).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorGroup(user) {
    return axios.get(`/v1/api/monitor/group/${user}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorIndustryNewsList(params) {
    return axios.post('/v1/api/monitor/industry/news-list', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorIndustryTag(user, groups) {
    return axios.post('/v1/api/monitor/industry/tag', { user, groups }).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorCount(user) {
    return axios.get(`/v1/api/monitor/count/${user}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorIndustryList(user, pageNum, pageSize) {
    return axios.post('/v1/api/monitor/industry/tag', { 
      user, 
      page_num: pageNum, 
      page_size: pageSize 
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getAddMonitorIndustry(user, industries) {
    return axios.post('/v1/api/monitor/industry', { user, industries }).then(
      res => {
        return res.data;
      }
    );
  }

  static deleteMonitorIndustry(user, industry) {
    return axios.delete('/v1/api/monitor/industry', { data: { user, industry } }).then(
      res => {
        return res.data;
      }
    );
  }

  static getEventTrendData(id) {
    return axios.get(`/v1/api/event/trend/${id}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getEventNewsList(order, id) {
    return axios.post('/v1/api/event/news', { order, id }).then(
      res => {
        return res.data;
      }
    );
  }

  static getRankCompany(market, sentiment) {
    return axios.post('/v1/api/rank/company', { market, sentiment }).then(
      res => {
        return res.data;
      }
    );
  }

  static getRankEvent() {
    return axios.get('/v1/api/rank/event').then(
      res => {
        return res.data;
      }
    );
  }

  static getCompanyEventList(company, pageNum, pageSize, eventId) {
    return axios.post('/v1/api/company/event/list', {
      company,
      page_num: pageNum,
      page_size: pageSize,
      event_id: eventId
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getCompanyPerimeterEvent(company, pageNum, pageSize, eventId) {
    return axios.post('/v1/api/company/perimeter/event', {
      company,
      page_num: pageNum,
      page_size: pageSize,
      event_id: eventId
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getRecommendImportantNewsSearch(pageNum, pageSize, searchText) {
    return axios.post('/v1/api/recommend/important-news/search', { pageNum, pageSize, searchText }).then(
      res => {
        return res.data;
      }
    );
  }

  static getRecommendEventSearch(pageNum, pageSize, searchText, order) {
    return axios.post('/v1/api/recommend/event/search', { 
      pageNum, 
      pageSize, 
      searchText, 
      order 
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getEventRelated(id) {
    return axios.get(`/v1/api/event/related/${id}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getAtlasRelationChart(source, target, selectedPath) {
    return axios.post('/v1/api/atlas/relation/chart', { 
      source,
      target,
      selected_path: selectedPath
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getAtlasRelationPath(source, target) {
    return axios.post('/v1/api/atlas/relation/path', { 
      source,
      target
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getEventRelatedCompany(id) {
    return axios.get(`/v1/api/event/related-company/${id}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getRelatedCompanyEvidence(companyName) {
    return axios.get(`/v1/api/related-company/${companyName}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getCompanyRefer(company, relatedCompany, relation) {
    return axios.post('/v1/api/company-refer', { 
      company,
      related_company: relatedCompany,
      relation
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getKeywordList(params) {
    return axios.post('/v1/api/keyword-list', params).then(
      res => {
        return res.data;
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorKeywordList(username) {
    return axios.post(`/v1/api/monitor/keyword/list/${username}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorKeywordPageList(params) {
    return axios.post('/v1/api/monitor/keyword/list', params).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorKeyword(params) {
    return axios.post('/v1/api/monitor/keyword', params).then(
      res => {
        return res.data;
      }
    );
  }

  static deleteMonitorKeyword(id) {
    return axios.delete(`/v1/api/monitor/keyword/${id}`).then(
      res => {
        return res.data;
      }
    );
  }

  static putMonitorKeyword(params) {
    return axios.put('/v1/api/monitor/keyword', params).then(
      res => {
        return res.data;
      }
    );
  }

  static getThemeTags() {
    return axios.get('/v1/api/theme-tags').then(
    // return axios.get('/mock/theme-filter1.json').then(
      res => {
        return res.data;
      }
    );
  }

  static getAddMonitorTheme(user, themes) {
    return axios.post('/v1/api/monitor/theme', { user, themes }).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorThemeList(user, pageNum, pageSize) {
    return axios.post('/v1/api/monitor/theme/list', { 
      user, 
      page_num: pageNum,
      page_size: pageSize 
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorThemeTagList(user) {
    return axios.get(`/v1/api/monitor/theme/${user}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorIndustryTagList(user, pageNum, pageSize) {
    return axios.post('/v1/api/monitor/industry/list', { 
      user, 
      page_num: pageNum,
      page_size: pageSize 
    }).then(
      res => {
        return res.data;
      }
    );
  }

  static deleteMonitorTheme(id) {
    return axios.delete(`/v1/api/monitor/theme/${id}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorThemeNewsList(params) {
    return axios.post('/v1/api/monitor/theme/news-list', params).then(
      res => {
        return res.data;
      }
    );
  }

  static getThemeNewsList(params) {
    return axios.post('/v1/api/theme-news-list', params).then(
      res => {
        return res.data;
      }
    );
  }

  static addMonitorPerson(user, person) {
    return axios.post('/v1/api/monitor/person', { user, person }).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorPersonList(params) {
    return axios.post('/v1/api/monitor/person/list', params).then(
      res => {
        return res.data;
      }
    );
  }

  static deleteMonitorPerson(id) {
    return axios.delete(`/v1/api/monitor/person/${id}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorPersonNameList(user) {
    return axios.get(`/v1/api/monitor/person/${user}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorPersonNewsList(params) {
    return axios.post('/v1/api/monitor/person/news-list', params).then(
      res => {
        return res.data;
      }
    );
  }

  static getPersonNewsList(params) {
    return axios.post('/v1/api/person-news-list', params).then(
      res => {
        return res.data;
      }
    );
  }

  static getMonitorPersonStatus(user, person) {
    return axios.get(`/v1/api/monitor/person-status?user=${user}&person=${person}`).then(
      res => {
        return res.data;
      }
    );
  }

  static getPdfDownload(url, fileName, source, date) {
    return axios.post('/v1/api/pdf/download', { url }, { responseType: 'blob' }).then(
      response => {
        const newUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        // const fileName = filename;
        const fname = `${fileName}-${source}-${date}.pdf`;
        link.href = newUrl;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return Promise.resolve(true);
      },
      err => {
        return Promise.reject(err.response);
      }
    );
  }

  static getPdfData(url) {
    return axios.post('/v1/api/pdf/download', { url }, {
      responseType: 'arraybuffer'
    }).then(
      res => {
        return Promise.resolve(res.data);
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getMonitorGroupWithCompanyList(user) {
    return axios.get(`/v1/api/monitor/group_with_company/count/${user}`).then(
      res => {
        return res.data;
      }
    );
  }

  static deleteMonitorGroupWithCompany(user, groupName) {
    return axios.delete('/v1/api/monitor/group_with_company', { data: { user, group_name: groupName } }).then(
      res => {
        return res.data;
      }
    );
  }

  static putMonitorGroupAndCompany(params) {
    return axios.put('/v1/api/monitor/group_and_company', params).then(
      res => {
        return res.data;
      }
    );
  }
}

